import client from "../client";
import { CreateBankAccountRequest, SaveXeroConfigRequest, TestXeroConnectionResult } from "./xeroServices";

// MYOB accounting-integration operations. These mirror the equivalent Xero
// service functions in `xeroServices.ts` — the AppSync accounting layer is
// provider-generic, so the response shapes reuse the shared AccountingConnection
// type. Field names are the MYOB counterparts of the Xero GraphQL fields.

export type SaveMyobConfigRequest = SaveXeroConfigRequest;
export type TestMyobConnectionResult = TestXeroConnectionResult;

export const connectMyob = (callback_url: string) => {
  return client({
    query: `
      mutation ConnectMyob($callback_url: String!) {
        connect_myob(callback_url: $callback_url) {
          organisation_id
          provider
          status
          is_authenticated
          tenant {
            id
            name
          }
          last_refreshed_at
          last_used_at
          updated_at
          disconnect {
            by
            reason
          }
          config {
            transactions_to_sync
            default_bank_account {
              id
              name
              code
              description
            }
          }
        }
      }
    `,
    variables: { callback_url }
  });
};

export const disconnectMyob = () => {
  return client({
    query: `
      mutation DisconnectMyob {
        disconnect_myob {
          organisation_id
          provider
          status
          is_authenticated
          tenant {
            id
            name
          }
          last_refreshed_at
          last_used_at
          updated_at
          disconnect {
            by
            reason
          }
          config {
            transactions_to_sync
            default_bank_account {
              id
              name
              code
              description
            }
          }
        }
      }
    `,
    variables: {}
  });
};

export const testMyobConnection = () => {
  return client({
    query: `
      query TestMyobConnection {
        test_myob_connection {
          status
          last_tested_at
        }
      }
    `,
    variables: {}
  });
};

export const saveMyobConfig = (data: SaveMyobConfigRequest) => {
  return client({
    query: `
      mutation SaveMyobConfig($input: SaveMyobConfigInput!) {
        save_myob_config(input: $input) {
          organisation_id
          provider
          status
          is_authenticated
          tenant {
            id
            name
          }
          last_refreshed_at
          last_used_at
          disconnect {
            by
            reason
          }
          config {
            transactions_to_sync
            sync_assets_enabled
          }
        }
      }
    `,
    variables: { input: data }
  });
};

export const createMyobBankAccount = (data: CreateBankAccountRequest) => {
  return client({
    query: `
      mutation CreateMyobBankAccount ($input: CreateMyobBankAccountInput) {
        create_myob_bank_account (input: $input) {
          code
          message
        }
      }`,
    variables: {
      input: data
    }
  });
};

export const getOrganisationMyobAccounts = () => {
  return client({
    query: `
      query GetOrganisationMyobAccounts {
        get_organisation_myob_accounts {
          accountId
          code
          name
          description
          taxType
        }
      }`,
    variables: {}
  });
};

export const getOrganisationMyobTaxCodes = () => {
  return client({
    query: `
      query GetOrganisationMyobTaxCodes {
        get_organisation_myob_tax_codes {
          taxType
          name
        }
      }
    `,
    variables: {}
  });
};

export const getOrganisationMyobCategories = () => {
  return client({
    query: `
      query GetOrganisationMyobCategories {
        get_organisation_myob_categories {
          trackingCategoryID
          name
          options {
            trackingOptionID
            name
          }
        }
      }`,
    variables: {}
  });
};
